import { render, staticRenderFns } from "./PictureInfo.vue?vue&type=template&id=45a1a4da&scoped=true&"
import script from "./PictureInfo.vue?vue&type=script&lang=ts&"
export * from "./PictureInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PictureInfo.vue?vue&type=style&index=0&id=45a1a4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1a4da",
  null
  
)

export default component.exports